import { useTranslation } from "react-i18next";
import styles from "./StatusComponent.module.scss";

interface Props {
  text: string;
}

const StatusComponent: React.FC<Props> = ({ text }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.base + " " + styles["statusCodes" + text]}>
        <div>{t(`statusCodes.${text}`)}</div>
      </div>
    </>
  );
};

export default StatusComponent;
